export default __webpack_public_path__ + "static/media/vatican_media.6cc16995.svg";